import { FormlyFieldConfig } from '@ngx-formly/core';
import { advancedSection, COMMON_FIELD_CONFIGS } from './field-config-shared';

/**
 * checkbox: type → label → required → [Advanced: width, prefillLastValue]
 */
export function getCheckBoxFieldConfigurationFields(): FormlyFieldConfig[] {
  return [
    COMMON_FIELD_CONFIGS['type'],
    COMMON_FIELD_CONFIGS['label'],
    COMMON_FIELD_CONFIGS['required'],
    advancedSection(COMMON_FIELD_CONFIGS['width'], COMMON_FIELD_CONFIGS['prefillLastValue']),
  ];
}
